import {Matrix4, Vector3} from 'three';
import {createXRStore} from '@react-three/xr';

export const xrStore = createXRStore({
  depthSensing: false,
  cameraAccess: true,
});

export const hitTestMatrix4 = new Matrix4();

export const POS_SKY = new Vector3(0, 10, 0);

export const HUMAN_HEIGHT = 1.6;

export const RAYCAST_MAX_DIST = 10;

export const LAYERS = {
  DEFAULT: 0,
  SHADOW: 1,
};

export const screenTouch = {
  position: new Vector3(0, 0, 1),
};
